import { Button } from "@/atoms-react/button/Button.react";
import { Modal, ModalContent, type ModalProps } from "@/atoms-react/modal/index.react";
import { useUser } from "@/features/user/hooks/use-user";
import type { AliasMobile, MobileCreate } from "@/features/user/types";
import { ChevronRightIcon } from "@heroicons/react/20/solid";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FormAddMobile } from "../form-add-mobile/index.react";
import { Base } from "@/atoms-react/text/Text.react";
import { Checkbox } from "@/atoms-react/input-checkbox/index.react";

type ModalAddAddressProps = {
  mobile?: AliasMobile;
  onValidated?: (address: MobileCreate) => void;
} & ModalProps;

export const ModalAddMobile = ({
  mobile,
  onValidated = () => {},
  ...props
}: ModalAddAddressProps) => {
  const { t } = useTranslation(["atoms"]);
  const { useUserProfile } = useUser();

  const { data: user, isLoading: isLoadingUser } = useUserProfile();
  const [newMobile, setNewMobile] = useState<MobileCreate>({
    MobileIndicatif: "",
    MobileNumber: "",
    main: false
  });

  useEffect(() => {
    if (isLoadingUser) return;

    setNewMobile((data) => ({
      ...data,
      UUID: user?.naturalPerson?.UUID
    }));
  }, [user]);

  const [mobileValid, setMobileValid] = useState(false);

  return (
    <Modal {...props} maxWidthClassName="max-w-2xl">
      <ModalContent
        title={
          mobile
            ? t("molecules.modal_add_mobile.title_modify")
            : t("molecules.modal_add_mobile.title")
        }
      >
        <div className={"mt-4 flex flex-col items-end opacity-1"}>
          <div className={"mt-4 mb-6 w-full"}>
            <FormAddMobile
              autoFocus
              onChange={(phone, valid) => {
                setNewMobile((mobile) => ({
                  ...mobile,
                  MobileIndicatif: phone.countryPrefix,
                  MobileNumber: phone.phone || ""
                }));
                setMobileValid(valid);
              }}
            />
          </div>
          <Checkbox
            value={newMobile.main}
            required={false}
            onChange={(value) => setNewMobile({ ...newMobile, main: value })}
            dataCy="checkbox-main"
          >
            <Base className="mb-6 cursor-pointer">{t("molecules.modal_add_mobile.main")}</Base>
          </Checkbox>

          <Button
            disabled={!mobileValid}
            shortcut="enter"
            className="w-max shrink-0"
            onClick={() => onValidated(newMobile)}
            icon={<ChevronRightIcon />}
            dataCy="save-alias-mobile"
          >
            {t("molecules.modal_add_address.confirm")}
          </Button>
        </div>
      </ModalContent>
    </Modal>
  );
};
